import { getPmPeriodByCurrentPeriod } from '../../constants/shared/CommonConstants';

const interventionsParser = response => {
    const interventions = {};
    Object.keys(response).forEach(period => {
        const pmPeriod = getPmPeriodByCurrentPeriod(period);
        interventions[pmPeriod] = response[period];
    });
    return interventions;
};

export default interventionsParser;
